import clsx from 'clsx';

import type { IconType } from '../../../types/SharedIconProps';
import type { PlaceholderSize } from '../types';

import { Icon } from '../../Icon/Icon';
import './PlaceholderMedia.css';

const BAR_COUNT = 6;

export function PlaceholderMedia({
  illustrationSrc,
  isLoading,
  size,
  icon,
}: {
  illustrationSrc: string | null;
  isLoading: boolean;
  size?: PlaceholderSize;
  icon?: IconType;
}) {
  const sizeClassName = clsx(
    'eds-placeholder-media',
    `eds-placeholder-media--size-${size}`,
  );

  if (isLoading) {
    return (
      <div
        aria-hidden
        className={clsx(sizeClassName, 'eds-placeholder-media--loading')}
      >
        {Array.from({ length: BAR_COUNT }, (_, index) => (
          <span
            className={clsx(
              'eds-placeholder-media--bar',
              `eds-placeholder-media--bar--${index + 1}`,
            )}
            key={index}
          />
        ))}
      </div>
    );
  }

  if (illustrationSrc) {
    return (
      <img
        alt=""
        className={clsx(sizeClassName, 'eds-placeholder-media--illustration')}
        src={illustrationSrc}
      />
    );
  }

  if (icon) {
    return (
      <span className="eds-placeholder-media--icon-badge">
        <Icon icon={icon} size="m" />
      </span>
    );
  }

  return null;
}
